module.exports = __webpack_public_path__ + "files/8ef9bef68aa63b8724aad236374f9359.mp3";